import React, { HTMLAttributes } from 'react'
import { styles } from './DuoImages.css'
import { SanityAssetDocument } from 'next-sanity'
import { SanityImage } from '../SanityImage'

interface DuoImagesProps extends HTMLAttributes<Element> {
	orientation?: boolean
	withText?: boolean
	largeImage: SanityAssetDocument
	smallImage: SanityAssetDocument
}

export const DuoImages: React.FC<DuoImagesProps> = ({
	orientation = true,
	withText = false,
	largeImage,
	smallImage,
}) => {
	if (!largeImage || !smallImage) return null

	const { base, image, primaryFigure, secondaryFigure } = styles()

	return (
		<div className={base({ orientation, withText })}>
			{orientation ? (
				<>
					<SanityImage
						figureClass={primaryFigure()}
						className={image()}
						image={largeImage.image}
						alt={largeImage.alt || ''}
					/>
					<SanityImage
						figureClass={secondaryFigure()}
						className={image()}
						image={smallImage.image}
						alt={smallImage.alt || ''}
					/>
				</>
			) : (
				<>
					<SanityImage
						figureClass={secondaryFigure()}
						className={image()}
						image={smallImage.image}
						alt={smallImage.alt || ''}
					/>
					<SanityImage
						figureClass={primaryFigure()}
						className={image()}
						image={largeImage.image}
						alt={largeImage.alt || ''}
					/>
				</>
			)}
		</div>
	)
}
